import { create } from 'zustand';
import type {
  CameraState,
  EngineId,
  InteractionMode,
  LayerManifest,
  Selection,
  TimeContext,
} from '../map/core/types';

export type SpatialStore = {
  engine: EngineId;
  camera: CameraState;
  selection: Selection;
  interactionMode: InteractionMode;
  time: TimeContext;
  layers: Record<string, LayerManifest>;
  rendererError?: string;
  setEngine: (engine: EngineId) => void;
  setCamera: (camera: CameraState) => void;
  setSelection: (selection: Selection) => void;
  setInteractionMode: (mode: InteractionMode) => void;
  setTime: (time: TimeContext) => void;
  registerLayers: (layers: LayerManifest[]) => void;
  updateLayer: (id: string, patch: Partial<LayerManifest>) => void;
  setRendererError: (message?: string) => void;
};

export const useSpatialStore = create<SpatialStore>((set) => ({
  engine: 'cesium',
  camera: { longitude: 10, latitude: 18, height: 18_500_000, heading: 0, pitch: -90, roll: 0 },
  selection: { type: 'none' },
  interactionMode: 'select',
  time: { mode: 'live', currentTime: new Date().toISOString(), playbackSpeed: 1 },
  layers: {},
  setEngine: (engine) => set({ engine }),
  setCamera: (camera) => set({ camera }),
  setSelection: (selection) => set({ selection }),
  setInteractionMode: (interactionMode) => set({ interactionMode }),
  setTime: (time) => set({ time }),
  registerLayers: (layers) => set((state) => ({
    layers: { ...state.layers, ...Object.fromEntries(layers.map((layer) => [layer.id, layer])) },
  })),
  updateLayer: (id, patch) => set((state) => ({
    layers: {
      ...state.layers,
      [id]: { ...state.layers[id], ...patch },
    },
  })),
  setRendererError: (rendererError) => set({ rendererError }),
}));
